/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessPeriod
 */
export interface BusinessPeriod {
    /**
     * 
     * @type {string}
     * @memberof BusinessPeriod
     */
    timeStart: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessPeriod
     */
    timeEnd: string;
}

export function BusinessPeriodFromJSON(json: any): BusinessPeriod {
    return BusinessPeriodFromJSONTyped(json, false);
}

export function BusinessPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessPeriod {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timeStart': json['timeStart'],
        'timeEnd': json['timeEnd'],
    };
}

export function BusinessPeriodToJSON(value?: BusinessPeriod | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timeStart': value.timeStart,
        'timeEnd': value.timeEnd,
    };
}


